
































































































import { Mixins, Component, Ref } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import * as I from '@/interfaces';
import AxMonitorElement from '@/components/layout/AxMonitorElement.vue';
import AxMonitorContext from '@/components/layout/AxMonitorContext.vue';
import AxMonitorAllContext from '@/components/layout/AxMonitorAllContext.vue';
import { HubConnectionBuilder, LogLevel, HubConnection } from '@microsoft/signalr';

class WebsocketState {
  isSize = 0;
  isDestroyed: boolean;
  isConnection: boolean;
  connection!: HubConnection;
  listGridDoor!: AxMonitorElement[];
  listGridSensor!: AxMonitorElement[];
  listEvent!: I.MonitorSimpleEvent[];

  constructor() {
    this.isDestroyed = false;
    this.isConnection = false;
  }

  Delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async Connect() {
    if (this.isDestroyed) return;
    const { hostname } = window.location;
    //const baseURL = process.env.NODE_ENV === 'development' ? `https://'${hostname}':44393` : '';
    const baseURL = process.env.NODE_ENV === 'development' ? `https://localhost:44393` : '';
    if (this.isSize === 0) {
      this.isSize = 1;
      if (this.listGridDoor)
        this.listGridDoor.forEach(grid => {
          grid.Resize(1024, 768);
        });
    }
    // 이미 연결이 열려 있는지 확인
    if (this.isConnection === true) {
      console.log('Connection is already open');
      return;
    }
    this.connection = new HubConnectionBuilder()
      .withUrl(baseURL + '/EventHub', {
        accessTokenFactory: () => 'test'
      })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();
    // SignalR 연결 이벤트 처리
    this.connection.onclose(() => {
      this.isConnection = false;
      console.log('SignalR 연결이 끊어졌습니다. 다시 연결을 시도합니다.');
      this.Connect(); // 연결 재시도
    });
    this.connection
      .start()
      .then(() => {
        this.SetEvent();
        this.GetDoorStatus();
        this.isConnection = true;
        console.log('SignalR 연결 성공', 'MonitoringMap');
      })
      .catch(async (err: Error) => {
        console.error('SignalR 연결 실패:', err);
      });
  }

  AddEvent(event: I.MonitorSimpleEvent) {
    console.log(event);
    this.listEvent.splice(0, 0, event);
    if (this.listEvent.length > 30) {
      this.listEvent.splice(this.listEvent.length - 1, 1);
    }
  }

  SetEvent() {
    this.connection.on('sendDoorEvent', (event: I.MonitorSimpleEvent) => {
      this.listGridDoor.forEach(door => {
        if (door.door.doorID === event.doorID) {
          console.log(event);
          this.AddEvent(event);
          door.AddEvent(event);
        }
      });
    });
    this.connection.on('DoorConnectionChanged', (status: I.DoorConnectionStatus) => {
      this.listGridDoor.forEach(door => {
        if (door.door.doorID === status.doorId) {
          door.state.isConnected = status.connected;
        }
      });
    });
    this.connection.on('DoorStatus', (status: I.DoorStatus) => {
      this.listGridDoor.forEach(door => {
        if (door.door.doorID === status.doorId) {
          door.state.isConnected = status.connected;
          door.state.doorStatus = status.doorStatus;
        }
      });
    });
    this.connection.on('DoorStatusChange', (status: I.SLAEvent) => {
      this.listGridDoor.forEach(door => {
        if (door.door.doorID === status.doorId) {
          door.state.doorStatus = status.eventCode;
        }
      });
    });
    this.connection.on('SensorEvent', (status: I.SensorEvent) => {
      this.listGridSensor.forEach(sensor => {
        if (sensor.sensor.sensorID === status.SensorId) {
          sensor.state.doorStatus = status.EventCode;
        }
      });
    });
    this.connection.on('DoorControlResult', (account, result, msg) => {
      console.log(account);
      console.log(result);
      console.log(msg);
      // if (account == 'administrator' && result == false) {
      //   this.EventBus.$emit('ShowModalText', {
      //     text: msg,
      //     title: '오류'
      //   });
      // }
    });
  }

  onDoorControl(groupid: number, doorid: number, controlcode: number) {
    console.log('monitoring control: doorid' + doorid);
    console.log('monitoring control: groupid' + groupid);
    this.connection
      .invoke('DoorControl', 'administrator', groupid, doorid, controlcode)
      .then(() => {
        // this.SetDoorStatus();
      })
      .catch((err: Error) => console.error(err.toString()));
  }

  GetDoorStatus() {
    const listDoor: number[] = [];
    this.listGridDoor.forEach(door => {
      listDoor.push(door.door.doorID);
    });

    this.connection
      .invoke('GetDoorStatus', listDoor)
      .then(() => {
        // this.SetDoorStatus();
      })
      .catch((err: Error) => console.error(err.toString()));
  }

  SetDoorStatus() {
    console.log('a');
  }

  SetWebSocketEvent() {
    this.connection.onclose(() => {
      console.log('ws disconnected!');
      // this.EventBus.$emit('WebSocketDisconnected');
      // this.ConnectWebSocket();
    });
    // this.RecvPacket(this.connection);
  }
}

@Component
export default class Monitoring extends Mixins(AxPage) {
  @Ref()
  listGridDoor!: AxMonitorElement[];

  @Ref()
  listGridSensor!: AxMonitorElement[];

  @Ref()
  img!: HTMLImageElement;

  @Ref()
  context!: AxMonitorContext;

  @Ref()
  contextall!: AxMonitorAllContext;

  @Ref()
  listEvent!: I.MonitorSimpleEvent[];

  @Ref()
  isConnection!: boolean;

  onItemsCollectionChanged() {
    if (this.latestInfo.action === 'Monitoring') {
      return;
    }
    if (this.groupNo !== this.latestInfo.groupId) {
      if (this.isConnection === false) {
        this.prepare();
      } else {
        this.websocketState.isDestroyed = true;
        this.websocketState.connection.stop();
        this.prepare();
      }
    }
  }

  onToggleVisibility() {
    this.isVisible = !this.isVisible; // isVisible 값을 토글합니다.
    this.tableHeight = this.isVisible ? '300' : '900'; // 가시성에 따라 높이를 조절합니다.
  }

  onWebSocketCheck() {
    console.log('소켓상태:', this.websocketState);
    if (this.websocketState.connection.connectionStarted === false) {
      this.websocketState.Connect();
    }
  }

  mounted() {
    setInterval(() => this.onItemsCollectionChanged(), 2000);
    //setInterval(() => this.onWebSocketCheck(), 5000);
  }

  beforeDestroy() {
    console.log('소켓연결 끊어졌습니다.');
    this.websocketState.isDestroyed = true;
    this.websocketState.connection.stop();
  }

  onDoorClick(door: I.MonitorDoor) {
    console.log('ondoorclick' + door.doorID);
    this.selectDoorId = door.doorID;
  }

  onDoorUpdate(door: I.MonitorDoor) {
    const find = this.listDoor.find(x => x.doorID === door.doorID);
    if (find) {
      this.listDoor.splice(this.listDoor.indexOf(find), 1, door);
    }
  }

  BottomClick(e: MouseEvent) {
    if (this.context) {
      this.contextall.Hide(e);
      this.context.Show(e, this.selectDoorId);
    }
  }

  BottomAllClick(e: MouseEvent) {
    if (this.contextall) {
      this.context.Hide(e);
      this.contextall.Show(e, this.selectDoorId);
    }
  }

  HidenClick(e: MouseEvent) {
    console.log('button' + e.button);
    if (this.context) {
      this.contextall.Hide(e);
      this.context.Hide(e);
    }
  }

  HidenAllClick(e: MouseEvent) {
    console.log('button' + e.button);
    if (this.contextall) {
      this.context.Hide(e);
      this.contextall.Hide(e);
    }
  }

  onOpenClick(doorid: number, controlcode: number) {
    console.log('monitoring: doorid' + doorid);
    this.websocketState.onDoorControl(this.latestInfo.groupId, doorid, controlcode);
  }

  doorAllOpen(controlcode: number) {
    console.log('doorlist');
    console.log(this.listGridDoor);
    for (const idx in this.listGridDoor) {
      const doorid = this.listGridDoor[idx].id;
      this.websocketState.onDoorControl(this.latestInfo.groupId, doorid, controlcode);
    }
  }

  async ElementSave() {
    const listDoor = this.listDoor;
    const listSensor = this.listSensor;
    const listOutput = this.listOutput;
    const listElement = this.listElement;

    const result = await this.API.call.monitor.elementUpdate({
      listDoor,
      listSensor,
      listOutput,
      listElement
    });
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      await this.showErrorModal('알림', '저장되었습니다.');
    }
  }

  onOpenAllClick(itype: number, controlcode: number) {
    switch (itype) {
      case 1:
      case 2:
      case 3:
        this.doorAllOpen(controlcode);
        break;
      case 6:
        this.ElementSave();
        break;
    }
  }

  width = 0;
  height = 0;
  itemsPerPage = -1;
  map!: string;
  isVisible = true;
  tableHeight = 300;
  monitorGroup!: I.MonitorGroup;
  listDoor: I.MonitorDoor[] = [];
  listSensor: I.MonitorSensor[] = [];
  listEvent: I.MonitorSimpleEvent[] = [];
  listOutput: I.MonitorOutput[] = [];
  listElement: I.MonitorElement[] = [];
  websocketState!: WebsocketState;
  groupNo: number;
  selectDoorId: number;

  async prepare() {
    if (this.isConnection === true) {
      console.log('prepare: 이미 연결되어 있습니다.');
      return;
    }
    if (this.latestInfo.controller === 'MONITOR' && this.latestInfo.groupId !== 0) {
      this.groupNo = this.latestInfo.groupId;
      //this.setLoading(true);
      const baseData = await this.getMonitoringInfo();
      if (baseData) {
        this.monitorGroup = baseData;
        this.listDoor = baseData.listDoor;
        console.log('listDoor');
        console.log(this.listDoor);
        this.listSensor = baseData.listSensor;
        if (baseData.map) {
          this.map = 'data:image/png;base64,' + baseData.map;
        }
        this.ConnectWebSocket();
        this.width = this.img.clientWidth;
        this.height = this.img.clientHeight;

        window.addEventListener('resize', e => {
          //윈도우 리사이즈 체크, 도면 사이즈 변경 저장
          console.log(e);
          console.log(this.img);
          // const margenleft = (window.innerWidth - 226) / 2 - this.img.clientWidth / 2;
          this.width = this.img.clientWidth;
          this.height = this.img.clientHeight;

          if (this.listGridDoor)
            this.listGridDoor.forEach(grid => {
              grid.Resize(this.width, this.height);
            });
          if (this.listGridSensor)
            this.listGridSensor.forEach(grid => {
              grid.Resize(this.width, this.height);
            });
        });
      }
      // this.setLoading(false);
    }
  }
  async getMonitoringInfo() {
    const result = await this.API.call.monitor.groupInfo(this.latestInfo.groupId);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async ConnectWebSocket() {
    this.websocketState = new WebsocketState();
    await this.$nextTick(() => {});
    this.websocketState.listGridDoor = this.listGridDoor;
    this.websocketState.listGridSensor = this.listGridSensor;
    this.websocketState.listEvent = this.listEvent;
    this.websocketState.Connect();
  }
  get countEmpty() {
    return 16 - this.listSensor.length - this.listDoor.length;
  }

  get headers() {
    return [
      { text: '출입문', value: 'doorName', align: 'start' },
      { text: '이름', value: 'name', align: 'start' },
      { text: '카드번호', value: 'uid', align: 'start' },
      { text: '사용자정보', value: 'userInfo', align: 'start' },
      { text: '이벤트시간', value: 'eventTime', align: 'start' },
      { text: '이벤트명', value: 'eventName', align: 'start' }
    ];
  }

  // $destroy() {
  //   if (this.websocketState) {
  //     this.websocketState.isDestroyed = true;
  //   }
  // }
}
